export { default } from "@features/investments/screens/watchlist-screen";
